import { Schedule } from "../MainObjects/Schedule";
import store from "../../store/store";

// Tools
const ft = require("./FileTools");

export function translateJSDateTimeToSQL(dateTime) {
  return (
    dateTime.getFullYear() +
    "-" +
    (dateTime.getMonth() + 1) +
    "-" +
    dateTime.getDate() +
    " " +
    dateTime.getHours() +
    ":" +
    dateTime.getMinutes() +
    ":" +
    dateTime.getSeconds()
  );
}

export async function convertScheduleSQLToJS(scheduleSQL, update = false) {
  let sign = "";

  if (update) {
    await ft
      .createMd5(store.state.config.dirs.root + scheduleSQL.path)
      .then((response) => {
        sign = response;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const projectName = scheduleSQL.path
    .replace("mediacenter/" + store.state.user.socId, "")
    .split("/")
    .join("_")
    .replace(".zip", "");

  const days = [
    {
      day: "monday",
      active: scheduleSQL.mon,
    },
    {
      day: "tuesday",
      active: scheduleSQL.tue,
    },
    {
      day: "wednesday",
      active: scheduleSQL.wed,
    },
    {
      day: "thursday",
      active: scheduleSQL.thu,
    },
    {
      day: "friday",
      active: scheduleSQL.fri,
    },
    {
      day: "saturday",
      active: scheduleSQL.sat,
    },
    {
      day: "sunday",
      active: scheduleSQL.sun,
    },
  ];

  const path = scheduleSQL.path.replace("mediacenter/" + store.state.user.socId, "");
  const path_dl = store.state.config.url.server + "/" + scheduleSQL.path;

  const projectData = {
    id_proj: scheduleSQL.proj_id,
    id_sched: scheduleSQL.id_sched,
    soc_id: scheduleSQL.soc_id,
    name: projectName,
    path: path,
    path_dl: path_dl,
    group: scheduleSQL.group,
    signature: sign,
    rank: scheduleSQL.rank,
    not_found: scheduleSQL.not_found,
  };

  const duration = scheduleSQL.sched_time;
  let permanent = false;

  // if the schedule info are all set to null and all days are true we make the permanent switch on
  if (
    scheduleSQL.fromDate == null &&
    scheduleSQL.fromTime == null &&
    scheduleSQL.toDate == null &&
    scheduleSQL.toTime == null &&
    scheduleSQL.mon &&
    scheduleSQL.tue &&
    scheduleSQL.wed &&
    scheduleSQL.thu &&
    scheduleSQL.fri &&
    scheduleSQL.sat &&
    scheduleSQL.sun
  )
    permanent = true;

  const timeExtract = extractTimeFromSQL(
    scheduleSQL.fromDate,
    scheduleSQL.fromTime,
    scheduleSQL.toDate,
    scheduleSQL.toTime
  );
  const loop_limit = scheduleSQL.loop_limit;
  const loop_duration = scheduleSQL.loop_duration;

  const schedule = new Schedule(
    projectData,
    days,
    permanent,
    duration,
    timeExtract.dateFrom,
    timeExtract.timeFrom,
    timeExtract.dateTo,
    timeExtract.timeTo,
    loop_limit,
    loop_duration
  );
  return schedule;
}

function extractTimeFromSQL(fromDate, fromTime, toDate, toTime) {
  let dateFrom = null;
  let timeFrom = null;
  let dateTo = null;
  let timeTo = null;

  if (fromDate != null) {
    dateFrom = fromDate.slice(0, 10);
  }
  if (fromTime != null) {
    timeFrom = fromTime.slice(0, -3);
  }
  if (toDate != null) {
    dateTo = toDate.slice(0, 10);
  }
  if (toTime != null) {
    timeTo = toTime.slice(0, -3);
  }

  return {
    dateFrom: dateFrom,
    timeFrom: timeFrom,
    dateTo: dateTo,
    timeTo: timeTo,
  };
}

export function isNullWhereFormat(value) {
  if (value == null) {
    return " IS NULL";
  }

  return " = " + value;
}

export function insertNullFormat(value) {
  if (value == null) {
    return "null";
  }

  return value;
}
